import { ConfigContext } from '@/config/config-context';
import axios from 'axios';
import { useContext } from 'react';
import { API_Type, Chat_Type } from './api';
import { ConversationType } from '@/components/chat-window/chat-window';

const usePublicApi = () => {
	const config = useContext(ConfigContext);

	const postMessage = async (
		inputValue: string
	): Promise<ConversationType | null> => {
		if (!config) {
			console.warn('Config instance not initialized');
			return null;
		}
		try {
			const response = await axios.post(
				`${config?.baseUrl}/${API_Type.Chats}/${Chat_Type.Message}`,
				{
					message: inputValue,
				}
			);

			if (response.status !== 200) {
				throw new Error('Network response was not ok');
			}

			const data: ConversationType = response.data;
			return data;
		} catch (error) {
			console.error('Error posting message:', error);
			throw error;
		}
	};

	return {
		postMessage,
	};
};

export default usePublicApi;
